<template>
  <section class="ws-advanced-search">
    <ws-filter-item
      id="humanreadble"
      :type="filterType.SEARCH"
      :label="$t('Поиск по ID')"
      @ready="onHumanIdReady"
      @change="onHumanIdChange"
    >
    </ws-filter-item>
    <header
      class="ws-advanced-search__header"
      @click="isOpen = !isOpen"
    >
      <h3
        class="ws-advanced-search__title has-text-primary is-size-2"
        v-text="title"
      ></h3>
      <div class="ws-advanced-search__actions">
        <button
          class="ws-button button is-text"
          :aria-controls="id"
        >
          <ws-icon
            class="ws-button__icon"
            name="arrow-thin"
            color="#000000"
            :class="{'ws-icon--left': !isOpen}"
            :fill="false"
            :title="$t('Свернуть/Развернуть')"
            width="17"
            height="11"
          />
        </button>
      </div>
    </header>
    <b-collapse
      :aria-id="id"
      class="ws-advanced-search__form"
      :open.sync="isOpen"
    >
      <div class="columns">
        <div class="column">
          <ws-permission-node :resources="['resources/region']">
            <ws-filter-item
              id="region_guid"
              resourceId="region"
              field="title.display"
              :type="filterType.REFBOOK"
              :label="$t('Регион')"
              entity="public/refbook/region"
              :params="{country: config.default_country_code}"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </ws-permission-node>
        </div>
        <div class="column">
          <ws-permission-node :resources="['resources/competency']">
            <ws-filter-item
              id="competency_guid"
              resource-id="competency"
              field="name.display"
              :type="filterType.REFBOOK"
              :label="$t('Профессия/специальность (ДЭ)')"
              entity="competence"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </ws-permission-node>
        </div>
        <div class="column">
          <ws-filter-item
            id="de_center_guid"
            field="name.display"
            :type="filterType.REFBOOK"
            :label="$t('ЦПДЭ')"
            entity="de-centers"
            @ready="onFilterReady"
            @change="onFilter"
          >
            <template
              slot="item"
              slot-scope="props"
            >
              <div class="is-flex">
                <p>
                  <small v-if="props.option.visible === false" class="icon-overlay">
                    <ws-icon
                      name="stop"
                      color="red"
                      height="15"
                      width="13"
                      class="icon-stop"
                    />
                  </small>
                  <span>
                    {{ props.option.name.display }}
                  </span>
                </p>
              </div>
              <small class="has-text-grey">{{ props.option.address.region.title.display }},
                <span v-if="props.option.address.locality">{{ props.option.address.locality.title.display }}</span>,
                {{ props.option.address.address.display }}
              </small>
            </template>
          </ws-filter-item>
        </div>
        <div class="column">
          <ws-filter-item
            id="exam_status"
            :type="filterType.SELECT"
            :label="$t('Статус экзамена')"
            @ready="onFilterReady"
            :options="exam_statuses"
            :default-value="default_exam_status"
            @change="onFilter"
          >
          </ws-filter-item>
        </div>
        <div
          class="column"
          style="flex-grow: initial; align-self: center;"
        >
          <button
            class="ws-button button is-text"
            @click="isToggleExpandedFilters = !isToggleExpandedFilters"
          >
            <ws-icon
              class="ws-button__icon"
              name="filter"
              :fill="true"
              :color="`#777`"
              :title="$t('Расширенный список фильтров')"
              width="18"
              height="18"
            />
          </button>
        </div>
      </div>

      <div
        class="ws-advanced-search__filters-expanded"
        v-show="isToggleExpandedFilters"
      >
        <div class="columns is-multiline">
          <div class="column is-2">
            <ws-filter-item
              id="started_at.from"
              :label="$t('Дата начала (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="started_at.till"
              :label="$t('Дата начала (до)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="ended_at.from"
              :label="$t('Дата окончания (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="ended_at.till"
              :label="$t('Дата окончания (до)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="created_at.from"
              :label="$t('Дата создания (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="created_at.till"
              :label="$t('Дата создания (до)')"
              :type="filterType.DATE"
              :position="'is-bottom-left'"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="updated_at.from"
              :label="$t('Дата редактирования (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="updated_at.till"
              :label="$t('Дата редактирования (до)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="day_cm1.from"
              ref="day_cm1.from"
              :label="$t('Дата ПД (от)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="day_cm1.till"
              ref="day_cm1.till"
              :label="$t('Дата ПД (до)')"
              :type="filterType.DATE"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <ws-filter-item
              id="is_center_accred"
              :type="filterType.SELECT"
              :label="$t('Статус аккредитации ЦПДЭ')"
              @ready="onFilterReady"
              :options="[
                { label: $t('Не важно'), value: '' },
                { label: $t('Обследован'), value: 'true' },
                { label: $t('Не обследован'), value: 'false' }
              ]"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
          <div class="column is-4">
            <ws-permission-node :resources="['resources/university']">
              <ws-filter-item
                id="university_guid"
                field="title.display"
                resourceId="university"
                :type="filterType.REFBOOK"
                :label="$t('Образовательная организация')"
                entity="public/refbook/education/institution"
                @ready="onFilterReady"
                @change="onFilter"
              >
                <template
                  slot="item"
                  slot-scope="props"
                >
                  <p>
                     <ws-icon v-if="props.option.visible === false" name="stop" color="red" class="icon-stop" width="15" height="15"/>
                    {{ props.option.title.display }}
                  </p>
                  <small class="has-text-grey">{{ props.option.address.region && props.option.address.region.title.display }},
                    <span v-if="props.option.address.locality">{{ props.option.address.locality.title.display }}</span>,
                    {{ props.option.address.address.display }}
                  </small>
                </template>
              </ws-filter-item>
            </ws-permission-node>
          </div>
          <div class="column is-4">
            <ws-filter-item
              id="qualification_guid"
              field="name.translate.ru"
              :type="filterType.REFBOOK"
              :label="$t('Квалификация')"
              entity="skill-matrix/qualification"
              @ready="onFilterReady"
              @change="onFilter"
            >
            </ws-filter-item>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-2">
            <ws-filter-item
              id="is_fgos"
              :type="filterType.SELECT"
              :label="$t('ФГОС')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="is_spo"
              :type="filterType.SELECT"
              :label="$t('flags.secondary_degree')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="is_vo"
              :type="filterType.SELECT"
              :label="$t('Программа ВО')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="has_kod"
              :type="filterType.SELECT"
              :label="$t('Наличие КОД')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
          <div class="column is-2">
            <ws-filter-item
              id="is_noc"
              :type="filterType.SELECT"
              :label="$t('Статус НОК')"
              @ready="onFilterReady"
              @change="onFilter"
              :options="[
                  { label: $t('Не важно'), value: '' },
                  { label: $t('Да'), value: 'true' },
                  { label: $t('Нет'), value: 'false' }
                ]"
            >
            </ws-filter-item>
          </div>
        </div>
      </div>

    </b-collapse>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { constants } from '@/services/constants.service'
import WsFilterItem from '@/components/common/WsFilterItem'
import filterType from '@/components/common/data/filter-type.enum'
import examsFilterMixin from '@/mixins/exam-filter.mixin'

export default {
  name: 'WsRequestExamsFilter',
  components: { WsFilterItem },
  mixins: [examsFilterMixin],
  data () {
    return {
      constants,
      config: __config,
      exam_statuses: [],
      default_exam_status: `${constants.request_exams_status.NEW},${constants.request_exams_status.REVIEW_AUTH_ORG},${constants.request_exams_status.REVISION_AUTH_ORG},${constants.request_exams_status.REVIEW_DE_DEPARTMENT},${constants.request_exams_status.REVISION_DE_DEPARTMENT},${constants.request_exams_status.AGREED_DE_DEPARTMENT}`,
      filterType
    }
  },
  computed: {
    ...mapGetters('profile', ['getUserSourcesPermission']),
    ...mapGetters('authentication', ['getUserGuid']),
    ...mapState('authentication', ['resourcesPermissions', 'currentRole'])
  },
  methods: {
  },
  async created () {
    this.default_exam_status = `${constants.request_exams_status.NEW},${constants.request_exams_status.REVIEW_AUTH_ORG},${constants.request_exams_status.REVISION_AUTH_ORG},${constants.request_exams_status.REVIEW_DE_DEPARTMENT},${constants.request_exams_status.REVISION_DE_DEPARTMENT},${constants.request_exams_status.AGREED_DE_DEPARTMENT}`
    this.exam_statuses = [
      {
        value: this.default_exam_status,
        label: this.$t('exam_request.filter.status.all')
      },
      {
        value: `${constants.request_exams_status.NEW}`,
        label: this.$t('exam_request.filter.status.new')
      },
      {
        value: `${constants.request_exams_status.REVIEW_AUTH_ORG}`,
        label: this.$t('exam_request.filter.status.review_auth_org')
      },
      {
        value: `${constants.request_exams_status.REVISION_AUTH_ORG}`,
        label: this.$t('exam_request.filter.status.revision_auth_org')
      },
      {
        value: `${constants.request_exams_status.REVIEW_DE_DEPARTMENT}`,
        label: this.$t('exam_request.filter.status.review_de_department')
      },
      {
        value: `${constants.request_exams_status.REVISION_DE_DEPARTMENT}`,
        label: this.$t('exam_request.filter.status.revision_de_department')
      },
      {
        value: `${constants.request_exams_status.AGREED_DE_DEPARTMENT}`,
        label: this.$t('exam_request.filter.status.agreed_de_department')
      }
    ]
    // this.default_exam_status = constants.request_exams_status.UNDER_REVIEW
  }
}
</script>

<style lang="scss">
.icon-stop {
  display: inline-flex;
  align-self: center;
}

.icon-overlay {
  font-size: 1.2em;
}
</style>
